import axios from "axios";

// Create an axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:8000",
});

export const BASE_URL= process.env.REACT_APP_BASE_URL || "http://localhost:8000";
// Add interceptor to include the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("TOKEN");
    return config;
  },
  (error) => Promise.reject(error)
);

// Add interceptor to handle invalid token responses
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data && error.response.data.message === "Invalid token") {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export const get_admin_dashboard_data_api = async () => {
  try {
    console.log("getting data");
    const response = await axiosInstance.get("/get-admin-dashboard-data/");
    console.log("data received" + response.data);
    return response.data.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
    throw error.response.data.error || "Not Found";
  }
};
export const get_unique_artist_data_api = async () => {
  try {
    console.log("getting data");
    const response = await axiosInstance.get("/get-unique-artist-data/");
    console.log("data received" + response.data);
    return response.data.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
    throw error.response.data.error || "Not Found";
  }
};

export const get_artist_dashboard_data_api = async () => {
  try {
    console.log("getting data");
    const response = await axiosInstance.get("/get-artist-dashboard-data/");
    console.log("data received" + response.data);
    return response.data.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
    throw error.response.data.error || "Not Found";
  }
};

export const get_new_artist_ids_hint_api = async (name) => {
  try {
    console.log("getting data");
    const response = await axiosInstance.post("/get-new-artist-ids-hints/", { name });
    console.log("data received" + response.data);
    return response.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
    throw error.response.data.error || "Not Found";
  }
};

export const create_artist_by_admin_api = async (data) => {
  try {
    console.log("adding artist data", data);
    const response = await axiosInstance.post("/create-artist-by-admin/", data);
    console.log("data received", response.data);
    return response.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
    throw error.response.data.error || "Not Found";
  }
};


export const create_withdrawal_api = async (data) => {
  try {
    console.log("creating withdrawal with data", data);
    const response = await axiosInstance.post("/create-withdrawal-requests/", data);
    console.log("withdrawal created", response.data);
    return response.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
    throw error.response.data.error || "Not Found";
  } 
};

export const upload_excel_data_admin_api = async (excelFile) => {
  try {
    console.log("uploading excel file", excelFile);
    const formData = new FormData();
    formData.append("excel_file", excelFile);
    const response = await axiosInstance.post("/upload-data-admin/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": "Bearer " + localStorage.getItem("TOKEN")
      }
    });
    console.log("data received", response.data);
    return response.data;
  } catch (error) {
    console.log("error - " + error.response.data.error);
  }
};


export const get_all_artists_api = async () => {
  try {
    const response = await axiosInstance.get("/get-all-artists/");
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to fetch artists";
  }
};

export const edit_artist_by_admin_api = async (data) => {
  try {
    const response = await axiosInstance.post("/edit-artist-by-admin/", data);
    return response.data;
  } catch (error)
 {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to update artist";
  }
};

export const get_all_withdraw_request_api = async () => {
  try {
    const response = await axiosInstance.get("/get-all-withdraw-request/");
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to fetch withdrawal requests";
  }
};

export const edit_withdraw_request_api = async (data) => {
  try {
    const response = await axiosInstance.post("/edit-withdraw-request/", data);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to update withdrawal request";
  }
};

export const get_artist_withdraw_requests_api = async () => {
  try {
    const response = await axiosInstance.get("/get-artist-withdraw-requests/");
    console.log("artist withdrawal requests", response.data);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to fetch artist withdrawal requests";
  }
};

export const update_artist_bank_details_api = async (data) => {
  try {
    const response = await axiosInstance.post("/update-artist-bank-details/", data);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to update bank details";
  }
};

export const get_report_options_api = async (reportType) => {
  try {
    const response = await axiosInstance.get(`/get-report-options/?report_type=${reportType}`);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || `Failed to fetch ${reportType} options`;
  }
};

export const get_advance_report_dashboard_data_api = async (data) => {
  try {
    const response = await axiosInstance.post(`/get-advance-report-dashboard-data/`, data);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to fetch advance report data";
  }
};

export const get_platforms_api = async () => {
  try {
    const response = await axiosInstance.get("/get-platforms/");
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to fetch platforms";
  }
};

export const bulk_delete_data_api = async (data) => {
  try {
    const response = await axiosInstance.post("/bulk-delete-data/", data);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to delete data";
  }
};

export const count_data_to_delete_api = async (data) => {
  try {
    const response = await axiosInstance.post("/count-delete-data/", data);
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to count data";
  }
};

export const delete_artist_account_api = async (data) => {
  try {
    const response = await axiosInstance.post("/delete-artist-account/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to delete artist account";
  }
};

export const update_analytics_data_api = async (data) => {
  try {
    const response = await axiosInstance.post("/update-analytics-data/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to update analytics data";
  }
};

export const get_home_page_data_api = async () => {
  try {
    const response = await axiosInstance.get("/content/get-home-page-data/");
    return response.data;
  } catch (error) {
    console.log("error - " + (error.response?.data?.error || error.message));
    throw error.response?.data?.error || "Failed to fetch home page data";
  }
};

export const update_home_content_api = async (data) => {
  try {
    const response = await axiosInstance.post("/content/update-home-content/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to update home content";
  }
};

export const submit_contact_form_api = async (data) => {
  try {
    const response = await axiosInstance.post("/content/submit-contact-form/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to submit contact form";
  }
};

export const get_all_leads_api = async () => {
  try {
    const response = await axiosInstance.get("/content/get-all-leads/");
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to fetch leads";
  }
};

export const update_lead_api = async (data) => {
  try {
    const response = await axiosInstance.post("/content/update-lead/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to update lead";
  }
};

export const get_new_leads_count_api = async () => {
  try {
    const response = await axiosInstance.get("/content/get-new-leads-count/");
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || "Failed to fetch new leads count";
  }
};

const create_manage_api = (url) => async (method, data) => {
  try {
    const config = { method, url: `/content/${url}/`, data };
    if (method === 'DELETE') {
        config.data = { id: data.id }; // axios delete body
    }
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
     throw error.response?.data?.error || "Operation failed";
  }
};

export const manage_service_api = create_manage_api('manage-service');
export const manage_project_api = create_manage_api('manage-project');
export const manage_stat_api = create_manage_api('manage-stat');
export const manage_social_link_api = create_manage_api('manage-social-link');
export const manage_featured_release_api = create_manage_api('manage-featured-release');
export const manage_singer_api = create_manage_api('manage-singer');

